import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import UserTableCell from 'components/molecules/TableCells/UserTableCell/UserTableCell';
import StyledUserTableCellEdit
  from 'components/organisms/TableCellEdits/UserTableCellEdit/UserTableCellEdit.styles';
import UserList from 'components/molecules/Lists/UserList/UserList';
import {withMemo} from 'helpers/wrapper';
import constants from 'helpers/constants';
import {useSnackbar} from 'components/organisms/Providers/SnackbarProvider/SnackbarProvider';

const UserTableCellEdit = withMemo(React.forwardRef((props, ref) => {
  const {
    cell,
    table,
    user,
    short,
    proxies,
    removeEnabled,
    onChange,
    ...innerProps
  } = useComponentProps({
    proxies: true,
    ...props
  }, 'UserTableCellEdit');

  const snackbar = useSnackbar();

  const handleClick = (e, newUser) => {
    const newValue = (removeEnabled && +user?.userId === +newUser.userId) ? null : newUser;

    cell.column.columnDef.optimistic.set(cell, newValue);
    table.setEditingCell(null);
    utils.asPromise(onChange)(cell.row.original, newValue)
      .catch(() => {
        cell.column.columnDef.optimistic.reset(cell);
        table.setEditingCell(cell);
        snackbar.show('Saving failed', null,
          {color: 'error', autoHideDuration: constants.delay.error});
      });

    e.preventDefault();
  }

  return <StyledUserTableCellEdit ref={ref} {...innerProps}
                                  cell={cell}
                                  table={table}
                                  TableCellPopperProps={{
                                    size: 'medium',
                                    density: 'densest'
                                  }}
                                  Anchor={<UserTableCell user={user}
                                                         short={short}
                                                         active={true} />}>
    <UserList user={user}
              proxies={proxies}
              track={true}
              removeEnabled={removeEnabled}
              onClick={handleClick}/>
  </StyledUserTableCellEdit>
}));

UserTableCellEdit.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  table: PropTypes.object,
  cell: PropTypes.object,
  user: PropTypes.object,
  short: PropTypes.bool,
  proxies: PropTypes.bool,
  removeEnabled: PropTypes.bool,
  onChange: PropTypes.func
};

export default UserTableCellEdit;
